import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectCommonClients = (state: StoreSchema) =>
    state.commonData.common.clients
